import React from "react";

const WspolnotaRozliczenieZaleglosciFiltr = (props) => {

  const { wybranyFiltr, setWybranyFiltr } = props;
  
  const handleChange = e => setWybranyFiltr(e.target.value);

  return (
    <div className="filtr-wysokosc">
      <label htmlFor="filtrWysokosc">Wysokość zaległości:</label>
      <select 
        id="filtrWysokosc"
        value={wybranyFiltr}
        onChange={handleChange}
      >
        <option value={1}>
          od 1 do 2 czynszów
        </option>
        <option value={2}>
          od 2 czynszów
        </option>
      </select>
    </div>
  )
}

export default WspolnotaRozliczenieZaleglosciFiltr;